import type { RouteLocationNormalized } from 'vue-router'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
    const utmSource: string = to.query?.utm_source as string

    if (utmSource && utmSource !== '') {
        useCookie('utmSource', {
            maxAge: 2592000, // 30 days
            secure: true,
        }).value = utmSource
    }
})
